import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import DeleteIcon from '@mui/icons-material/Delete';
import { MutationKeyConfig } from '../../api/api-helper';
import { useDeleteData } from '../../hooks/useDeleteData';
import { ApiErrorComponent } from '../api-error.component';
import { LoadingIndicator } from '../loading-indicator.component';
import { useState } from 'react';
import { backdropClasses, IconButton, Tooltip, Typography } from '@mui/material';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';

interface DeleteGridButtonProps {
  data: any;
  deleteMutationConfig: (item: any) => MutationKeyConfig;
  onDeleted: (value: any) => any;
}

export const DeleteGridButton = ({ data, deleteMutationConfig, onDeleted }: DeleteGridButtonProps) => {
  const { isLoading, isError, error, mutateAsync } = useDeleteData(deleteMutationConfig(data));
  const [isOpen, setIsOpen] = useState(false);

  const submitHanlder = async () => {
    await mutateAsync();
    onDeleted(data);
  };

  const openDialog = () => {
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <div className="delete-btn-container">
      <IconButton style={{ padding: 5 }} aria-label="delete" onClick={openDialog}>
        <Tooltip title={<Typography variant="body1">Delete</Typography>}>
          <DeleteIcon className="btnDelete" />
        </Tooltip>
      </IconButton>
      {isOpen && (
        <Dialog className="modalpopup" title={'CONFIRM DELETE'} onClose={closeDialog}>
          <div>
            <div style={{ padding: '25px 50px' }}>
              <div>Are you sure you want to permanently delete?</div>
              <LoadingIndicator isLoading={isLoading} />
              {/* <ApiErrorComponent isError={isError} errorRespnse={error} /> */}
            </div>
          </div>
          <DialogActionsBar>
            <div className=" spaceBetween">
              <button className="btn btn-sm btn-default btn-lightGrey" onClick={closeDialog} autoFocus>
                Cancel
              </button>
              <button
                className="btn btn-sm btn-danger btn-delete"
                style={{ backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#ff8a8a', color: isReadOnlyPermission ? 'black' : '#fff' }}
                type="button"
                onClick={submitHanlder}
                disabled={isLoading || isReadOnlyPermission}
              >
                Delete
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};
